import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { setDemoMode, setDemoCookies, setDemoLocalStorage } from '../../utils/demoMode';
import './Auth.css';

const MainPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleTryDemo = () => {
    setDemoMode(true);
    setDemoCookies();
    setDemoLocalStorage();
    window.location.href = '/dashboard';
  };

  return (
    <div className="auth-shell">
      <div className="auth-card">
          <p className="eyebrow">{t('auth_eyebrow_demo')}</p>
          <h1>
            <Trans i18nKey="auth_demo_title_html" components={{ em: <em className="serif-italic accent-text" /> }} />
          </h1>
          <p className="auth-sub">{t('auth_demo_sub')}</p>

          <button type="button" className="btn-submit" onClick={() => navigate('/signin')}>
            {t('Sign In')}
          </button>

          <div className="auth-sep"><span>{t('or')}</span></div>

          <button type="button" className="btn-secondary" onClick={() => navigate('/signup')}>
            {t('Sign Up')}
          </button>

          <p className="auth-foot">
            <button type="button" onClick={handleTryDemo}>{t('Try a live demo')}</button>
          </p>
        </div>
    </div>
  );
};

export default MainPage;
